import { render, staticRenderFns } from "./UomReselectionDialog.vue?vue&type=template&id=a69344a4&lang=pug&"
import script from "./UomReselectionDialog.vue?vue&type=script&lang=js&"
export * from "./UomReselectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports